<cmps-wait-status *ngIf="state?.pending?.summary"></cmps-wait-status>

<ng-container *ngIf="!state?.pending?.summary && !state?.summary">
    <div class="text-center">{{ i18n._711_NO_DATA_AVAILABLE | translate }}</div>
</ng-container>

<ng-container *ngIf="!state?.pending?.summary && state?.summary">
    <div
        cmpsPerformanceInsightCategory
        [summary]="state?.summary"
        [category]="state?.activeCategory"
        (categoryChange)="onCategoryChange($event)"
        [subCategory]="state?.activeSubCategory"
        (subCategoryChange)="onSubCategoryChange($event)"
        [definition]="state?.activeDefinition"
        (definitionChange)="onDefinitionChange($event)"
    ></div>

    <div class="text-right">
        <button
            class="btn btn-primary active"
            (click)="onAddClick()"
        >
            <span>Add</span>
        </button>
    </div>
</ng-container>
